// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-47e6d334]{display:none}.sf-button--pure[data-v-47e6d334]{--button-color:var(--c-accent-5);--button-font-size:18px;--button-font-weight:400}.sf-button--pure[data-v-47e6d334]:active,.sf-button--pure[data-v-47e6d334]:hover{--button-color:var(--c-primary)}.sf-button--pure .svg-image[data-v-47e6d334]{margin-right:6px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
